export const CHECKOUT_URL = "https://laser-en.impultienda.ar/checkout/";

export const MOCKUP_IMAGE =
  "https://cdn.magicpatterns.com/uploads/nqFUTmdimbG8HmS7WfCbhs/MOCKUP_LASER-EN.png";

export const AUTHOR_IMAGE =
  "https://cdn.magicpatterns.com/uploads/rRXQWTQQD8soj7fzCkGLnU/MICHAEL_CARTER_-_IMPLANTES.png";

export const collectionHighlights = [
  "6 specialized educational volumes",
  "5 exclusive professional bonuses",
  "Laser technology reference materials",
  "Skin assessment educational frameworks",
  "Treatment-planning worksheets",
  "Laser safety reference checklists",
  "Clinical documentation templates",
  "Educational case studies",
  "Follow-up documentation resources",
];

export const offerIncludes = [
  "Six specialized educational volumes",
  "Five professional bonuses",
  "Laser technology reference charts",
  "Skin assessment educational frameworks",
  "Treatment planning worksheets",
  "Laser safety reference checklists",
  "Educational case studies",
  "Clinical documentation templates",
  "Follow-up documentation resources",
  "No recurring subscription",
];

export const beforeItems = [
  "Your laser technology references are scattered across different documents.",
  "Finding a particular skin anatomy concept requires searching through multiple resources.",
  "Your educational materials about different laser platforms are difficult to compare.",
  "You want a more organized way to study skin assessment considerations.",
  "Your safety references and documentation templates aren’t always easy to locate.",
  "You need a structured educational resource that you can revisit.",
];

export const afterItems = [
  "Six educational volumes organized around distinct professional topics.",
  "Structured references for studying laser technology fundamentals.",
  "Educational frameworks for reviewing skin characteristics.",
  "Organized materials covering treatment-planning concepts.",
  "Safety education references and documentation checklists.",
  "Templates for organizing professional records and follow-up information.",
  "Educational case scenarios for structured review.",
];

export const challenges = [
  {
    title: "Your laser technology references are scattered",
    body: [
      "You’ve collected information from professional courses, textbooks, training materials, and technology manufacturers.",
      "But when you want to revisit a particular concept, finding the right reference can take longer than expected.",
    ],
    approach: "Bring related educational topics together in one organized reference collection.",
  },
  {
    title: "You want a clearer framework for studying skin characteristics",
    body: [
      "Understanding skin characteristics is an important part of aesthetic laser education.",
      "You want a structured way to study relevant skin anatomy, pigmentation concepts, skin responses, and individual variation.",
    ],
    approach:
      "Explore educational skin assessment frameworks and reference materials organized around relevant concepts.",
  },
  {
    title: "You want to understand different laser technologies",
    body: [
      "Different laser technologies have different characteristics, applications, limitations, and operating principles.",
      "You want to understand these differences without constantly jumping between disconnected resources.",
    ],
    approach:
      "Study educational references covering laser fundamentals, wavelength concepts, selective photothermolysis, and technology-specific characteristics.",
  },
  {
    title: "You need a more organized approach to treatment planning",
    body: [
      "Professional treatment planning involves multiple considerations, including the intended application, individual characteristics, technology-specific instructions, and potential contraindications.",
      "You want a structured way to organize the information you review.",
    ],
    approach:
      "Use educational planning worksheets and case-based exercises to structure professional learning and discussion.",
  },
  {
    title: "You want to keep safety and documentation resources accessible",
    body: [
      "Safety references, patient records, consent documentation, and follow-up information all play important roles in professional practice.",
      "You want these materials to be easier to locate and organize.",
    ],
    approach:
      "Access educational safety checklists, documentation templates, and follow-up worksheets that can be adapted to your professional setting.",
  },
  {
    title: "You want to organize your continuing professional education",
    body: [
      "Your knowledge develops over time as technologies, research, and professional guidance evolve.",
      "You want a reference library that helps you revisit important concepts and organize your learning.",
    ],
    approach:
      "Maintain a structured educational collection covering major areas of aesthetic laser education.",
  },
];

export const resources = [
  {
    title: "Laser Technology Reference Charts",
    body: "Educational comparison materials covering laser technology categories, wavelength concepts, and fundamental operating principles.",
  },
  {
    title: "Skin Assessment Frameworks",
    body: "Worksheets for organizing relevant skin characteristics, patient history information, and assessment considerations.",
  },
  {
    title: "Treatment Planning Worksheets",
    body: "Structured educational templates for reviewing treatment objectives, individual considerations, and device-specific documentation requirements.",
  },
  {
    title: "Laser Safety Checklists",
    body: "Educational checklists for reviewing safety principles, protective equipment considerations, and documentation practices.",
  },
  {
    title: "Clinical Documentation Templates",
    body: "Resources for organizing consultations, treatment records, photographs, and follow-up information.",
  },
];

export const testimonials = [
  {
    title: "A Well-Organized Educational Reference",
    quote:
      "I appreciate having the main concepts organized into separate volumes. The structure makes it easier to study laser physics, skin characteristics, technology differences, and safety considerations without jumping between unrelated topics. I see this type of resource as a useful supplement to continued professional education.",
    name: "Dr. Emily Parker",
    role: "Aesthetic Medicine Physician",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/26c621cb-7bc1-429a-8019-fdc2711452da.jpg",
  },
  {
    title: "A Useful Visual Learning Format",
    quote:
      "The combination of written explanations, comparison tables, and visual references makes the material easier to navigate. I particularly like having different subjects organized into dedicated sections, so I can focus on one topic at a time and return to the relevant material when needed.",
    name: "Sarah Mitchell, RN",
    role: "Registered Nurse",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/e0e1c6ca-698b-4e32-84bf-c2c5aaffa252.jpg",
  },
  {
    title: "A Structured Introduction to Laser Technology",
    quote:
      "Understanding aesthetic laser technology involves learning several connected concepts. I like that this collection separates the fundamentals of light and tissue interaction from the overview of different technologies. It creates a logical framework for reviewing terminology and identifying subjects that deserve further study.",
    name: "Daniel Roberts, MD",
    role: "Medical Doctor",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/a74d7075-f6c9-4c30-b110-6c0cff9805f3.jpg",
  },
  {
    title: "Practical Educational Worksheets",
    quote:
      "The worksheets and checklists provide an organized way to approach educational topics such as assessment, safety, and documentation. I would adapt these resources to the requirements of my own professional environment and use them alongside the relevant device instructions and established procedures.",
    name: "Jessica Bennett, LE",
    role: "Licensed Esthetician",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/03c70bf9-e2cd-49df-8bcd-bc1bf8a886b9.jpg",
  },
  {
    title: "A Comprehensive Collection of Learning Resources",
    quote:
      "I was looking for an educational reference that covered several areas of aesthetic laser technology rather than focusing on just one subject. The six-volume structure brings together physics, skin assessment, technology, planning concepts, safety, and documentation in one collection.",
    name: "Michael Thompson, PA-C",
    role: "Physician Associate",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/4797c736-6dc5-47c2-937f-8514393de9f1.jpg",
  },
  {
    title: "The Safety & Documentation Volumes I Keep Open",
    quote:
      "After years in dermatology nursing, I wanted one place to review laser fundamentals before moving into laser-based treatments. The safety and documentation volumes are the ones I return to most — they helped me organize my notes and prepare better questions for my device trainings.",
    name: "Laura Méndez, NP",
    role: "Aesthetic Nurse Practitioner",
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/9cb5f9ab-cf6d-42e1-a970-3553e1da3841.jpg",
  },
];

export const faqs = [
  {
    q: "How will I receive the materials?",
    a: [
      "AESTHETIC LASER CLINICAL BLUEPRINT™ is offered as a digital educational collection.",
      "After checkout, access details are sent to the email address you provide. The checkout page explains exactly how you’ll receive your purchase and access the included materials.",
    ],
  },
  {
    q: "What exactly is included?",
    a: [
      "Your collection includes six specialized educational volumes and five complementary bonuses.",
      "The volumes cover laser fundamentals, skin assessment, technology categories, educational treatment planning, safety considerations, and clinical documentation.",
      "The bonuses include technology comparison charts, consultation worksheets, safety checklists, hypothetical case studies, and additional documentation resources.",
    ],
  },
  {
    q: "Is this a physical product?",
    a: ["No. This is a digital educational product. No physical book or equipment is included."],
  },
  {
    q: "Who is this collection for?",
    a: [
      "The collection is intended for appropriately qualified aesthetic professionals, healthcare professionals working within their authorized scope, and eligible learners studying aesthetic laser technologies.",
      "The materials are educational references, not authorization to perform clinical procedures.",
    ],
  },
  {
    q: "Is this a complete clinical training course?",
    a: [
      "No. AESTHETIC LASER CLINICAL BLUEPRINT™ is an educational reference collection.",
      "It does not replace formal education, supervised practical training, device-specific instruction, or any qualifications required to perform aesthetic procedures.",
    ],
  },
  {
    q: "Does this collection replace professional judgment or clinical guidelines?",
    a: [
      "No. Clinical decisions must be made by appropriately qualified professionals using current evidence, device-specific instructions, applicable regulations, and individual patient circumstances.",
      "The materials are intended to complement professional education.",
    ],
  },
  {
    q: "Can I use the materials in any country?",
    a: [
      "The educational concepts may be relevant to learners in different countries. However, professional licensing requirements, device regulations, and clinical standards vary by jurisdiction.",
      "You are responsible for ensuring that your professional activities comply with the requirements applicable to your location.",
    ],
  },
  {
    q: "Can I download the files?",
    a: [
      "The checkout page clearly explains how access works and whether the materials are downloadable, including the available file formats.",
    ],
  },
  {
    q: "Is this a recurring subscription?",
    a: ["No. The listed price is a one-time payment of $27 USD. There is no recurring subscription for this offer."],
  },
  {
    q: "What if I decide the collection isn’t right for me?",
    a: [
      "Please review the refund policy displayed at checkout before purchasing, including eligibility requirements, the request procedure, and the deadline.",
    ],
  },
  {
    q: "Does this collection guarantee better clinical outcomes?",
    a: [
      "No. The collection does not guarantee clinical outcomes, treatment success, or improved patient results.",
      "Its purpose is to provide organized educational references and documentation resources that support continuing professional learning.",
    ],
  },
];

export const buyers = [
  { name: "Valentina R.", country: "Colombia", minutesAgo: 2 },
  { name: "Carlos M.", country: "Mexico", minutesAgo: 4 },
  { name: "Lucía F.", country: "Argentina", minutesAgo: 3 },
  { name: "Andrés P.", country: "Chile", minutesAgo: 6 },
  { name: "Camila S.", country: "Spain", minutesAgo: 1 },
  { name: "Diego H.", country: "Peru", minutesAgo: 5 },
  { name: "Sofía G.", country: "Ecuador", minutesAgo: 7 },
  { name: "Mateo L.", country: "Uruguay", minutesAgo: 2 },
  { name: "Isabella C.", country: "Costa Rica", minutesAgo: 9 },
  { name: "Gabriela T.", country: "Dominican Republic", minutesAgo: 3 },
  { name: "Javier N.", country: "Panama", minutesAgo: 8 },
  { name: "Daniela V.", country: "Guatemala", minutesAgo: 4 },
  { name: "Martín A.", country: "Paraguay", minutesAgo: 6 },
  { name: "Fernanda O.", country: "Bolivia", minutesAgo: 2 },
  { name: "Ricardo E.", country: "Venezuela", minutesAgo: 5 },
];
